import React from "react";
import useModal from "use-react-modal";
import WorkItem from "./WorkItem";

interface WorkViewProps {
  data: any;
}

const WorkView: React.FC<WorkViewProps> = ({ data }) => {
  const { isOpen, openModal, closeModal, Modal } = useModal();
  const { position, company } = data;

  return (
    <div className="col-md-6 col-lg-4" style={{ textAlign: "center" }}>
      <a
        className="portfolio-item d-block mx-auto mt-3"
        onClick={openModal}
        href={`#work`}
      >
        <h3> {position} </h3>
        <h5 style={{ color: "maroon" }}> {company} </h5>
      </a>
      {isOpen && (
        <Modal>
          <WorkItem {...data} onClose={closeModal} />
        </Modal>
      )}
      <hr />
    </div>
  );
};

export default WorkView;
